"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalLink = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const ExternalLink = ({ children, openUrl, url, style, }) => {
    if (react_native_1.Platform.OS === 'web') {
        return (react_1.default.createElement("a", { href: url, target: "_blank", rel: "noreferrer noopener" },
            react_1.default.createElement(react_native_1.View, { style: style }, children)));
    }
    else {
        return (react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: () => openUrl === null || openUrl === void 0 ? void 0 : openUrl(url), style: style }, children));
    }
};
exports.ExternalLink = ExternalLink;
